import React from 'react';
import {SignupForm} from '../modules/signup/components/SignupForm';
import {TruvuContainer} from '../components/containers/TruvuContainer';
import Typography from '@mui/material/Typography';
import {Stack} from '@mui/material';
import {useHistory} from 'react-router';
import {TruvuMenu} from '../components/TruvuMenu';

export function SignupPage() {
  const {push} = useHistory();

  const goToLogin = () => {
    push('/login');
  };

  return (
    <TruvuContainer onGoBack={goToLogin} skinny>
      <TruvuMenu my="20px" title="Sign up to Truvu" />
      <Stack>
        <SignupForm />
        <Typography
          component="label"
          color={'text.secondary'}
          variant="body2"
          htmlFor="goToSignup"
          mb={1}
          textAlign="center"
          mt={2}
        >
          Already have an account?{' '}
          <Typography
            sx={{cursor: 'pointer'}}
            component={'strong'}
            color={'primary'}
            onClick={goToLogin}
          >
            Login
          </Typography>
        </Typography>
      </Stack>
    </TruvuContainer>
  );
}
